<template>
  <div class="container py-5 d-flex justify-content-center align-items-center min-vh-100">
    <div
      class="login-card bg-white border-primary border animate__animated animate__fadeInDown p-4 rounded-4 shadow"
      style="max-width: 400px; width: 100%;"
    >
      <h3 class="text-center text-primary mb-4 fw-bold">
        <i class="fas fa-user me-2"></i> Autentificare Client
      </h3>
      <form @submit.prevent="login">
        <div class="mb-3">
          <label class="form-label fw-semibold">
            <i class="fas fa-envelope me-1 text-muted"></i> Email
          </label>
          <input v-model="email" type="email" class="form-control form-control-lg" placeholder="ex: client@email.ro" required />
        </div>
        <div class="mb-3">
          <label class="form-label fw-semibold">
            <i class="fas fa-lock me-1 text-muted"></i> Parolă
          </label>
          <input v-model="password" type="password" class="form-control form-control-lg" placeholder="••••••••" required />
        </div>
        <div class="mb-3">
          <label class="form-label fw-semibold">
            <i class="fas fa-robot me-1 text-muted"></i> Cât fac {{ captchaQ }}?
          </label>
          <input v-model="captchaInput" type="text" class="form-control form-control-lg" required />
        </div>
        <button type="submit" class="btn btn-primary w-100 btn-lg shadow-sm hover-scale">
          <i class="fas fa-sign-in-alt me-2"></i> Autentifică-te
        </button>
      </form>
      <div class="text-center mt-3">
        <router-link to="/client/register" class="text-decoration-none small text-muted">
          <i class="fas fa-user-plus me-1"></i> Nu ai cont? Creează unul
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import api from '@/api/axios'
import Swal from 'sweetalert2'
import { useRouter } from 'vue-router'

const router = useRouter()

const email        = ref('')
const password     = ref('')
const captchaInput = ref('')

// ✅ Captcha dinamic generat la runtime — mai greu de ghicit
const captchaA = Math.floor(Math.random() * 9) + 1
const captchaB = Math.floor(Math.random() * 9) + 1
const captchaQ      = `${captchaA} + ${captchaB}`
const captchaAnswer = String(captchaA + captchaB)

const login = async () => {
  if (captchaInput.value.trim() !== captchaAnswer) {
    Swal.fire('Eroare captcha', 'Răspuns greșit la întrebare.', 'error')
    return
  }

  try {
    const res    = await api.post('/client/login/', { email: email.value, password: password.value })
    const client = res.data.client

    localStorage.setItem('client_id', client.id)
    localStorage.setItem('client_name', client.full_name)

    // ✅ Notificăm App.vue să actualizeze starea de autentificare fără reload
    window.dispatchEvent(new Event('client-auth-changed'))

    await Swal.fire('Bine ai venit!', client.full_name, 'success')
    router.push('/client/dashboard')
  } catch (err) {
    Swal.fire('Eroare!', err.response?.data?.error || 'Date greșite.', 'error')
  }
}
</script>

<style scoped>
.hover-scale {
  transition: transform 0.2s ease-in-out;
}
.hover-scale:hover {
  transform: scale(1.03);
}
</style>